import React from 'react';
import styles from './Section5.module.scss';

const Section5 = () => {
  return (
    <div className={`${styles.container}`}>
      <div className={`${styles.contentContainer}`}>
        <div className={`${styles.headerContainer}`}>
          <div className={`${styles.heading}`}>Reach Out</div>
          <div className={`${styles.text1}`}>Feel free to reach out to us incase of any queries</div>
        </div>
        <div className={`${styles.actionBtn}`}>
          <a
            href="https://www.instagram.com/arre_voice/"
            target={'_blank'}
            rel={'noreferrer'}
            className="hover:underline"
          >
            <img width={'100%'} height={'100%'} src="/assets/images/instaDM.svg" alt="insta btn" />
          </a>
        </div>
        <div className={`${styles.text2}`}>
          E-mail us your queries on{' '}
          <span className={`${styles.text3}`}>
            <a href="mailto:prachee@arre.co.in" rel={'noreferrer'} target={'_blank'}>
              prachee@arre.co.in
            </a>
          </span>
        </div>
      </div>
    </div>
  );
};

export default Section5;
